// ** MUI Imports
import Card from '@mui/material/Card'
import { DataGrid, esES } from '@mui/x-data-grid'
import CardHeader from '@mui/material/CardHeader'

// ** Data Import
import {VisibilityIconButton} from "../../../components/buttons/Buttons";
import {useContext, useEffect, useState} from "react";
import {CompanyContext, CompanyContextValue} from "../../../pages/solicitation-new/context/companyContext";
import {ClientNotification, ClientNotificationFields} from "../../../types/client/clientData";
import {HttpOnboarding} from "../../../http/onboarding/httpOnboarding";
import DescriptionIcon from "@mui/icons-material/Description";
import {QueryStats} from "@mui/icons-material";
import {Avatar, Chip, Grid, Skeleton, Stack} from "@mui/material";
import {dateFormatter} from "../../../utils/formatters";
import {stringFormatter} from "../../../utils/formatters/stringFormatter";


const NotificationsTableBasic = () => {
  const {clientId} = useContext<CompanyContextValue>(CompanyContext)
  const [notifications, setNotifications] = useState<ClientNotification[]>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if (clientId !== 0) {
      setLoading(true)
      HttpOnboarding.getNotifications(clientId).then((r) => {
        setNotifications(r)
        setLoading(false)
      })
    }
  }, [clientId])


  const columns = [
    {
      flex: 0.05,
      field: 'tipo',
      headerName: '',
      renderCell: (params: any) => 
      params.row[ClientNotificationFields.Type] === 'Pedido de Documentación' ? <Avatar color={'secondary'}><DescriptionIcon/></Avatar>
        : <Avatar color={'secondary'}><QueryStats/></Avatar>
      
    },
    {
      flex: 0.25,
      field: 'titulo',
      headerName: 'Titulo'
    },
    {
      flex: 0.5,
      field: 'mensaje',
      headerName: 'Mensaje',
      renderCell: (params: any) => (
          params.row[ClientNotificationFields.Priority] ?
              <Stack direction={'row'} alignItems={'center'} spacing={2}>
                {stringFormatter.cutIfHaveMoreThan(params.row[ClientNotificationFields.Message], 65)}
                <Chip size={'small'} color={'warning'} label={'Importante'}/>
              </Stack>
              :
          stringFormatter.cutIfHaveMoreThan(params.row[ClientNotificationFields.Message], 75)
      )
    },
    {
      flex: 0.1,
      field: 'date',
      headerName: 'Fecha',
      renderCell: (params: any) => dateFormatter.toShortDate(params.row[ClientNotificationFields.Date])
    },
    {
      flex: 0.1,
      field: 'to',
      headerName: 'Accion',
      renderCell: (data: any) => (
          <VisibilityIconButton tooltipTitle={'Ver'} onClick={() => {
            window.open(`/solicitudes/${data.row[ClientNotificationFields.SolicitationId]}`, '_blank')
          }}/>
      )
    }
  ]

  return (
    <Card>
      <CardHeader title={'Notificaciones'} />
        {
            loading && 
            <Grid container p={0} spacing={0} gap={0}>
              <Grid item xs={12} m={0}><Skeleton height={80}/></Grid>
              {Array.from({length: 10}).map((d, k) => <Grid item xs={12} key={k} m={0}><Skeleton height={50}/></Grid>)}
            </Grid>
        }
        {
            notifications &&
              <DataGrid columns={columns}
                        rows={notifications}
                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        autoHeight
                        rowsPerPageOptions={[5, 10, 25]}
                        pageSize={pageSize}
                        onPageSizeChange={newPageSize => setPageSize(newPageSize)}
              />
        } 
    </Card>
  )
}

export default NotificationsTableBasic
